import React from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '../../../components/layout/Layout'
import { AICostTrends } from '../../../components/labs/ai-cost-trends'
import { SectionTitle } from '@multiagentbook/ui'
import { ToolsNav } from '../../../components/pages/nav'

const siteMetadata = {
  description:
    'Interactive visualization of AI API pricing trends from 2023-2025. Track how costs for GPT-4, Claude, Gemini, and other models have dropped by 100x+. Verifiable sources for every data point.',
  title: 'AI Cost Trends - API Pricing Over Time',
  author: 'Victor Dibia',
  image: '/images/og-card.png',
  keywords:
    'ai pricing, api costs, openai pricing, anthropic claude pricing, google gemini pricing, llm costs, gpt-4 pricing, token pricing',
  twitterUsername: '@designingwithml',
}

const AICostTrendsPage: React.FC = () => {
  const { t } = useTranslation('aiCostTrends')
  const { t: tCommon } = useTranslation('common')

  const breadcrumbPages = [
    { name: tCommon('nav.labs'), href: '/labs', current: false },
    { name: t('page.title'), href: '/labs/ai-cost-trends', current: true },
  ]

  return (
    <Layout
      meta={siteMetadata}
      title={t('page.title')}
      link="/labs/ai-cost-trends"
    >
      <main>
        {/* Breadcrumbs */}
        <ToolsNav pages={breadcrumbPages} />

        {/* Hero Section */}
        <div className="mb-8 mt-6">
          <SectionTitle title={t('page.title')} />
          <p className="text-lg text-secondary mt-2 max-w-3xl">
            {t('page.description')}
          </p>
        </div>

        {/* Main Component */}
        <AICostTrends />
      </main>
    </Layout>
  )
}

export default AICostTrendsPage
